import {Component, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-mute-self-audio-configuration-dialog',
  templateUrl: './mute-self-audio-configuration.component.html'
})
export class MuteSelfAudioConfigurationComponent implements OnInit {
  message: string;

  constructor(public dialog: NgbActiveModal) {
  }

  ngOnInit(): void {}

  onSubmit() {
    this.dialog.close(true);
  }

}
